import React from "react";

export default function LoadingSpinner({
  size = 24,
  className = "",
  label = "Loading...",
}) {
  return (
    <div
      className={`inline-flex items-center gap-2 ${className}`}
      role="status"
    >
      <svg
        className={`animate-spin text-primary-700 ${className}`}
        style={{ width: size, height: size }}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
        ></path>
      </svg>
      <span className="sr-only">{label}</span>
    </div>
  );
}
